var _defs, _metadata;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayAtCounter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 117.691 117.691",
    id: "svg18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "m 47.125,17.635 c 5.867,0.795 9.897,6.044 9.181,11.763 -0.684,5.463 -5.619,10.036 -11.977,9.196 -5.245,-0.694 -9.837,-5.648 -9.024,-11.822 0.701,-5.317 5.625,-9.976 11.82,-9.137 z",
    id: "path7",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "m 33.078,53.826 c -0.694,0.316 -1.382,0.723 -2.167,1.042 -2.505,1.019 -5.077,1.324 -7.747,0.642 -4.283,-1.095 -8.131,-5.186 -9.739,-8.633 -1.617,-3.466 2.618,-6.894 5.676,-4.537 0.857,0.661 1.806,2.433 2.568,3.42 2.11,2.731 4.794,3.499 8.219,1.11 0.392,-0.273 0.569,-0.326 0.924,-0.646 l 2.266,-2.289 c 1.164,-1.286 1.738,-1.82 4.245,-1.829 4.083,-0.013 8.169,0.002 12.252,0.002 4.287,0 7.062,-0.35 10.374,1.686 2.07,1.272 4.287,4.111 5.489,6.754 4.223,9.283 4.166,22.283 3.65,32.389 -0.252,4.953 -4.854,5.106 -6.665,2.955 -1.177,-1.398 -0.854,-3.053 -0.765,-5.093 0.248,-5.75 0.23,-11.879 -0.539,-17.532 -0.346,-2.538 -1.363,-7.782 -2.552,-9.522 -0.258,2.37 -0.043,6.029 -0.043,8.538 v 40.909 H 46.878 c 0.008,-1.611 0.013,-3.196 0.013,-4.737 0,-4.246 0.183,-13.281 -0.013,-16.928 h -2.145 c -0.154,2.698 -0.022,5.786 -0.022,8.526 v 13.139 H 33.078 Z",
    id: "path9",
    style: {}
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svgFill",
    points: "31.233,70.865 20.177,70.865 20.177,66.641 31.233,66.641 ",
    id: "polygon11",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "m 71.096,70.772 33.527,0.022 V 66.683 H 73.638 l 0.04,-4.561 h 12.076 c 1.013,0 1.657,-0.831 1.428,-1.845 L 82.933,41.459 c 1.219,-0.222 2.938,-0.32 3.681,-0.324 0.274,1.741 0.897,3.942 1.333,5.702 l 3.361,13.372 c 0.242,0.981 0.277,2.104 1.328,2.096 1.063,-0.008 1.113,-1.167 1.357,-2.183 l 2.003,-7.719 c 0.438,-1.885 0.908,-3.785 1.347,-5.668 0.226,-0.963 1.067,-4.997 1.375,-5.545 0.933,-0.016 3.404,0.539 4.016,0.149 0.464,-0.295 0.586,-1.235 0.111,-1.645 -0.362,-0.311 -1.172,-0.35 -1.767,-0.423 -4.668,-0.566 -3.945,-0.638 -4.93,3.552 -0.57,2.428 -1.137,4.861 -1.731,7.274 -0.3,1.222 -0.563,2.424 -0.86,3.626 l -0.916,3.549 -0.349,-1.178 c -0.294,-1.176 -0.568,-2.37 -0.846,-3.551 L 88.63,40.707 C 88.413,39.75 88.376,39.106 87.4,39.012 86.12,38.888 83.852,39.175 82.442,39.438 82.083,38.595 81.188,37.951 80.296,37.951 H 53.172 c -1.015,0 -1.658,0.831 -1.429,1.845 l 0.103,0.455 c 2.691,0.036 6.42,0.343 9.069,1.971 1.185,0.728 2.391,1.87 3.465,3.193 1.095,1.347 2.065,2.891 2.738,4.369 2.328,5.171 3.317,10.899 3.761,16.506 0.108,1.495 0.177,2.983 0.217,4.482 z M 92.535,19.934 c -4.059,-0.533 -7.351,2.542 -7.76,6.05 -0.485,4.158 2.48,7.36 6.057,7.8 4.107,0.506 7.384,-2.493 7.804,-6.052 0.499,-4.211 -2.467,-7.321 -6.101,-7.798 z m 0.206,-2.313 c 5.341,0.712 8.807,5.327 8.208,10.342 -0.564,4.715 -4.855,8.771 -10.342,8.133 -4.744,-0.551 -8.807,-4.859 -8.142,-10.355 0.313,-2.587 1.908,-5.04 3.267,-6.019 2.097,-1.51 4.13,-2.485 7.009,-2.101 z",
    id: "path13",
    style: {}
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayAtCounter);
export default __webpack_public_path__ + "static/media/payAtCounter.2ffcc841bfcf5ecbf51605a03d3d77e1.svg";
export { ForwardRef as ReactComponent };